import { changePasswordHeaderStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { borderBottomTitlesStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(changePasswordHeaderStyles, {
    headerGridContainer: {
        css: css`
            ${borderBottomTitlesStyles()};

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [20, null, 40, null, null], properties: ["margin-bottom"], unit: "px" }],
                    mediaOptions.min,
                )}
        `,
    },
    titleGridItem: {
        css: css`
            align-items: center;
        `,
        width: [12, 12, 8, 9, 9],
    },
    title: {
        variant: "h1",
        as: "h1",
    },
    buttonGridItem: {
        width: [0, 0, 4, 3, 3],
    },
});
